import { CopilotApiService } from './lib/services/copilot.service';
import { provideState, provideStore, Store } from '@ngrx/store';
import { copilotReducer } from './lib/store/copilot.reducer';
import { provideEffects } from '@ngrx/effects';
import { CopilotEffects } from './lib/store/copilot.effects';
import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { CopilotFacadeService } from './lib/services/copilot-facade.service';

export * from './lib/store/copilot.actions';
export * from './lib/store/copilot.reducer';
export * from './lib/store/copilot.selectors';
export * from './lib/store/copilot.effects';
export * from './lib/services/copilot.service';
export * from './lib/services/copilot-facade.service';
export * from './lib/services/copilot-playbooks.service';
export * from './lib/services/copilot-context-composer.service';
export * from './lib/models/copilot.models';
export * from './lib/components/chat/chat.component';
export * from './lib/components/copilot-playbooks-panel/copilot-playbooks-panel.component';
export * from './lib/components/copilot-slash-menu/copilot-slash-menu.component';

export function provideCopilot(): EnvironmentProviders {
  return makeEnvironmentProviders([
    Store,
    CopilotApiService,
    CopilotFacadeService,
    provideState({ name: 'copilot', reducer: copilotReducer }),
    provideEffects([CopilotEffects]),
  ]);
}
